import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Botão de novo cadastro
export const NovoCadastro = styled(Link)`
  display: block;
  padding: 20px 0 10px 0;
`;

// Container flexível para organizar o mapa e a tabela
export const ContainerFlex = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

// Estiliza o contêiner do mapa
export const MapaContainer = styled.div`
  flex: 1;
`;

// Estiliza o contêiner da tabela ao lado do mapa
export const TabelaContainer = styled.div`
  width: 700px;
  max-height: 500px;
  overflow-y: auto;
`;

// Estiliza a tabela
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

// Estiliza o cabeçalho da tabela
export const thStyle = styled.th`
  background-color: #f4f4f4;
  padding: '8px';
  border-bottom: 2px solid #ddd;
  text-align: left;
`;

// Estiliza as células da tabela
export const tdStyle = styled.td`
  padding: 8px;
  border-bottom: 1px solid #ddd;
`;

// Alterna a cor de fundo das linhas
export const rowEven = styled.tr`
  background-color: #ffffff;
`;

export const rowOdd = styled.tr`
  background-color: #f9f9f9;
`;
